module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 688
// module chunks = 1